// openEHR RM model — BMM package org.openehr.rm.common.tags
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../base/mod.ts";
import { applyRmInit, type RmInit } from "../../base/apply_rm_init.ts";

/**
 * A tag with optional value that is associated with a target information entity identified by a UID.
 */
export class ITEM_TAG {
  constructor(init?: RmInit) { applyRmInit(this, init); }

  /**
   * Internal storage for key
   * @protected
   */
  protected _key?: openehr_base.String;

  /**
   * The tag key. May not be empty or contain leading or trailing whitespace.
   */
  get key(): string | undefined {
    return this._key?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for key.
   * Use this to access openehr_base.String methods.
   */
  get $key(): openehr_base.String | undefined {
    return this._key;
  }

  /**
   * Sets key from either a primitive value or openehr_base.String wrapper.
   */
  set key(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._key = undefined;
    } else if (typeof val === "string") {
      this._key = openehr_base.String.from(val);
    } else {
      this._key = val;
    }
  }

  /**
   * Internal storage for value
   * @protected
   */
  protected _value?: openehr_base.String;

  /**
   * The value. If set, may not be empty.
   */
  get value(): string | undefined {
    return this._value?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for value.
   * Use this to access openehr_base.String methods.
   */
  get $value(): openehr_base.String | undefined {
    return this._value;
  }

  /**
   * Sets value from either a primitive value or openehr_base.String wrapper.
   */
  set value(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._value = undefined;
    } else if (typeof val === "string") {
      this._value = openehr_base.String.from(val);
    } else {
      this._value = val;
    }
  }

  /**
   * Identifier of target, which may be a \`VERSIONED_OBJECT<T>\` or a \`VERSION<T>\`.
   */
  target?: openehr_base.UID_BASED_ID;
  /**
   * Internal storage for target_path
   * @protected
   */
  protected _target_path?: openehr_base.String;

  /**
   * Optional archetype (i.e. AQL) or RM path within \`_target_\`, used to tag a fine-grained element.
   */
  get target_path(): string | undefined {
    return this._target_path?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for target_path.
   * Use this to access openehr_base.String methods.
   */
  get $target_path(): openehr_base.String | undefined {
    return this._target_path;
  }

  /**
   * Sets target_path from either a primitive value or openehr_base.String wrapper.
   */
  set target_path(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._target_path = undefined;
    } else if (typeof val === "string") {
      this._target_path = openehr_base.String.from(val);
    } else {
      this._target_path = val;
    }
  }

  /**
   * Identifier of owner object, such as EHR.
   */
  owner_id?: openehr_base.OBJECT_REF;
}
